import * as React from "react";

import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";

import { t } from "../../utils/i18n";

import { SimpleColumn } from "./columns";
import * as theme from "./theme.css";

class ViewAdjuster<ITEM> extends React.PureComponent<
    ViewAdjusterProps<ITEM>,
    ViewAdjusterState
> {
    state: ViewAdjusterState = {
        visible: false,
    };

    render = () => (
        <Dropdown
            overlay={this.buildOptions()}
            open={this.state.visible}
            onOpenChange={this.handleVisibleChange}
            placement="bottomRight"
            trigger={["click"]}
        >
            <a className="ant-dropdown-link" onClick={this.handleClick}>
                <>
                    {t("ControlResult_AdjustView")} <DownOutlined />
                </>
            </a>
        </Dropdown>
    );

    private buildOptions = () => {
        const { columns, visibleColumnIds, onChange, children } = this.props;
        const options: Array<React.ReactNode> = [];
        columns.forEach((col) => {
            if (col.display === "NEVER") {
                return;
            }
            const checked = visibleColumnIds.has(col.extractor.id);
            const columnId = col.extractor.id;
            options.push(
                <div key={columnId} className={theme.columnDropdownOption}>
                    <Checkbox
                        id={columnId}
                        checked={checked}
                        disabled={col.display === "ALWAYS"}
                        onChange={
                            col.display !== "ALWAYS"
                                ? (e: CheckboxChangeEvent) => {
                                      e.stopPropagation();
                                      const newVisibleColumnIds = new Set(
                                          visibleColumnIds
                                      );
                                      if (e.target.checked) {
                                          newVisibleColumnIds.add(columnId);
                                      } else {
                                          newVisibleColumnIds.delete(columnId);
                                      }
                                      onChange(newVisibleColumnIds);
                                  }
                                : undefined
                        }
                    >
                        {col.extractor.label}
                    </Checkbox>
                </div>
            );
        });
        return (
            <div className={theme.columnDropdown}>
                {children}
                <div>
                    <strong>{t("ControlResult_Columns")}</strong>
                </div>
                {options}
            </div>
        );
    };

    private handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
    };

    private handleVisibleChange = (visible: boolean) => {
        this.setState({ visible });
    };
}

interface ViewAdjusterProps<ITEM> {
    columns: Array<SimpleColumn<ITEM>>;
    visibleColumnIds: Set<string>;
    onChange: (visibleColumnIds: Set<string>) => void;
    children?: React.ReactNode;
}

interface ViewAdjusterState {
    visible: boolean;
}

export { ViewAdjuster, type ViewAdjusterProps };
